import * as React from 'react'

export default function CSRFInput() {
  const csrfParam = document.querySelector('meta[name=csrf-param]')?.getAttribute('content')
  if (!csrfParam) return null
  const csrfToken = document.querySelector('meta[name=csrf-token]')?.getAttribute('content')
  return <input type="hidden" name={csrfParam} value={csrfToken} />
}
